module.exports = __webpack_public_path__ + "img/02-1解决方案.8c80c65a.svg";